import React from 'react'
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import LoadingButton from "@mui/lab/LoadingButton";
import { trakrefFontFamilyBold } from "../../../utils";
import { trakrefBlue, trakrefDisabledBlue } from "../../../color_utils";

const LoadingButtonV4 = ({
    type,
    loading,
    onClick,
    buttonText,
    useLargeButton,
    disabled,
    width,
    onFocus,
    fullWidth,
    sx
}) => (
    <LoadingButton
        type={type}
        fullWidth={fullWidth}
        variant="contained"
        size={useLargeButton ? "large" : "medium"}
        loading={loading}
        onClick={onClick}
        disabled={disabled}
        onFocus={onFocus}
        sx={{
            height: useLargeButton ? "52px" : null,
            "& .MuiCircularProgress-root": {
                color: "#FFFFFF",
                width: "21px !important",
                height: "21px !important",
            },
            ...(width && { width: `${width}%`}),
            ...sx
        }}
        style={{
            backgroundColor: disabled ? trakrefDisabledBlue : trakrefBlue,
        }}
    >
        <Typography
            variant='h5'
            sx={{
                fontFamily: trakrefFontFamilyBold,
                color: loading ? "transparent" : "#fff",
                backgroundColor: disabled ? trakrefDisabledBlue : trakrefBlue,
                letterSpacing: "1.2px",
                padding: "2% 0%",
                fontSize: useLargeButton ? "17px" : "14px",
                fontWeight: 400,
            }}
        >
            {buttonText}
        </Typography>
    </LoadingButton>
);

LoadingButtonV4.propTypes = {
    loading: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    buttonText: PropTypes.string,
    useLargeButton: PropTypes.bool,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    width: PropTypes.string,
    onFocus: PropTypes.func,
    fullWidth: PropTypes.bool,
    sx: PropTypes.object
};

LoadingButtonV4.defaultProps = {
    buttonText: "Submit",
    useLargeButton: false,
    disabled: false,
    fullWidth: true,
    sx: {}
};

export default LoadingButtonV4;
